<div class="grid grid-rows-[auto_1fr_auto] h-[100dvh] w-full">
  <div>
    <ng-content select="[ctr-content-header]"></ng-content>
  </div>
  <div class="px-10 mx-auto w-full overflow-auto py-1" [style.max-width]="maxSize">
    <ng-content select="[ctr-content-body]"></ng-content>
  </div>
  <div class="bg-gray-50 shadow-[0px_0px_8px_rgba(0,0,0,0.25)]">
    <div class="px-10 max-w-[1280px] mx-auto w-full py-3" [style.max-width]="maxSize">
      <ng-content select="[ctr-content-footer]"></ng-content>
    </div>
  </div>
</div>
